import * as React from "react";
import { Path, Circle } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const PromoTag = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Circle cx={12} cy={12} r={9} />
    <Path
      d="m17.081 11.773-4.86-4.86a1.073 1.073 0 0 0-.76-.313H7.68c-.595 0-1.08.486-1.08 1.08v3.78c0 .297.118.567.318.767l4.86 4.86a1.073 1.073 0 0 0 1.523-.006l3.78-3.78c.2-.194.318-.464.318-.761a1.09 1.09 0 0 0-.319-.767Zm-4.54 4.552L7.68 11.46V7.68h3.78v-.005l4.86 4.86-3.78 3.79Z"
      fill="#fff"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.54 16.325 7.68 11.46V7.68h3.78v-.005l4.86 4.86-3.78 3.79ZM9.03 9.84a.81.81 0 1 0 0-1.62.81.81 0 0 0 0 1.62Z"
      fill="#fff"
    />
  </Icon>
);

export default PromoTag;
